<template>
  <div class="accordion" id="accordionExample">
    <div
      class="card training-card "
      v-for="(item, index) in trainingItems"
      :key="index"
    >
      <a :href="item.LinkToDetails" class="details-arrow">
        <img src="../../../../Assets/Images/left-white-arrow.png" alt="arrow" />
      </a>
      <div
        id="1"
        class="show"
        aria-labelledby="headingOne"
        data-parent="#accordionExample"
      >
        <div class="card-body">
          <div class="row data">
            <div class="img-wrapping desk-view">
              <div
                v-bind:style="{
                  backgroundImage: 'url(' + item.imageUrlDesktop + ')',
                }"
              ></div>
            </div>
            <div class="text-data">
                <div class="title-wrapper">
                    <div class="sep">
                        <a class="card-body card-title">{{ item.Title }} </a>
                        <div class="seprator mob-view"
                             style="background-image:url('../../../../Assets/Images/seprator.svg')"></div>
                    </div>
                    <div class="img-wrapping mob-view">
                        <img :src="item.imageUrlMobile" />
                    </div>
                </div>

                <div class="seprator desk-view "
                     style="background-image:url('../../../../Assets/Images/seprator.svg')"></div>
                <div class="data__details">
                    <div class="data__details__title">
                        {{ trainingObj.Status }}
                    </div>
                    <div>
                        <div class="data__details__description">
                            <span>
                                {{ item.Status == 'Closed' ?  ClosedStatus : OpenStatus }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="data__details">
                    <div class="data__details__title">
                        {{ trainingObj.From }}
                    </div>
                    <div class="data__details__description">
                        {{ item.DateFrom }}
                    </div>
                </div>
                <div class="data__details">
                    <div class="data__details__title">
                        {{ trainingObj.To }}
                    </div>
                    <div class="data__details__description">
                        {{ item.DateTo }}
                    </div>
                </div>

                <div class="data__details">
                    <div class="data__details__title">
                        {{ trainingObj.Type }}
                    </div>
                    <div class="data__details__description">
                        {{ item.Type }}
                    </div>
                </div>

                <div class="data__details">
                    <div class="data__details__title">
                        {{ trainingObj.FunctionsLabel }}
                    </div>
                    <div class="data__details__description"
                         v-if="item.functions != 0">
                        <span v-for="(func, index) in item.Functions" :key="index">
                            {{ func }}
                            <span v-if="index != item.Functions.length - 1">
                                -
                            </span>
                        </span>
                    </div>
                    <div class="data__details__description"
                         v-if="item.Functions == null">
                        -
                    </div>
                </div>

                <div class="data__details">
                    <div class="data__details__title">
                        {{ trainingObj.SectorLabel }}
                    </div>
                    <div class="data__details__description"
                         v-if="item.Sectors != 0">
                        <span v-for="(sec, index) in item.Sectors" :key="index">
                            {{ sec }}
                            <span v-if="index != item.Sectors.length - 1">
                                -
                            </span>
                        </span>
                    </div>
                    <div class="data__details__description"
                         v-if="item.Sectors == null">
                        -
                    </div>
                </div>

                <div class="data__details">
                    <div class="data__details__title">
                        {{ trainingObj.ProductsLabel }}
                    </div>
                    <div class="data__details__description"
                         v-if="item.HealthProducts != 0">
                        <span v-for="(prod, index) in item.HealthProducts"
                              :key="index">
                            {{ prod }}
                            <span v-if="index != item.HealthProducts.length - 1">
                                -
                            </span>
                        </span>
                    </div>
                    <div class="data__details__description"
                         v-if="item.HealthProducts == null">
                        -
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {};
  },
  props: {
    trainingObj: {
      type: Object,
    },
    trainingArr: {
      type: Array,
    },
    OpenStatus: {
      type: String
    },
    ClosedStatus: {
      ClosedStatus: String
    }
  },
  methods: {},
  computed: {
    trainingItems() {
      let lang = 'ar';
      if(location.pathname.includes('/en')) {
        lang = 'en';
      }
      this.trainingArr.map((x) => {
        x.DateFrom = moment(new Date(x.DateFrom))
          .locale(lang)
            .format("DD MMM YYYY | hh:mm A");
        x.DateTo = moment(new Date(x.DateTo))
          .locale(lang)
            .format("DD MMM YYYY | hh:mm A");
      });
      return this.trainingArr;
    }
  },
  mounted() {
    setTimeout(() => {
      this.trainingArr = this.trainingItems;
    }, 100);
  },
};
</script>
